module.exports = __webpack_public_path__ + "img/image6.1dcd8a07.webp";